class CurrencyCreateController {
  /*@ngInject*/
  constructor(
    Auth,
    $state,
    User,
    CurrencyService,
    Modal,
    $translate,
    $stateParams
  ) {
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.Service = CurrencyService;
    this.Modal = Modal;
    this.$translate = $translate;
    this.$stateParams = $stateParams;
    this.hasACL = {};

    this.defaultModel = {
      id: "",
      name: "",
      symbol: "",
      decimals: 2,
      sortOrder: 1,
    };
    this.loading = false;
    this.model = angular.copy(this.defaultModel);
    this.branchId = this.User.getUser().branchId;
  }

  $onInit() {
    // Initialize any required data
  }

  reset() {
    this.model = angular.copy(this.defaultModel);
    this.clearErrors();
  }

  clearErrors() {
    this.errors = {};
    this.errorMessage = "";
  }

  submit() {
    this.loading = true;
    this.clearErrors();

    this.Service.create({
      id: this.model.id,
      name: this.model.name,
      symbol: this.model.symbol,
      decimals: this.model.decimals,
      sortOrder: this.model.sortOrder,
    })
      .then((data) => {
        this.loading = false;
        this.askCreate();
      })
      .catch((err) => {
        this.loading = false;
        if (err && err.data && err.data.errors) {
          err.data.errors.forEach((e) => {
            this.errorMessage += e.message + "<br/>";
          });
        } else if (err && err.data && err.data.error) {
          // Handle single error message from API
          this.errorMessage = err.data.error;
        } else if (err && err.data && err.data.message) {
          this.errorMessage = this.$translate.instant(err.data.message);
        } else {
          this.errorMessage = this.$translate.instant('common.error_occurred');
        }
      });
  }

  askCreate() {
    this.Modal.confirm({
      header: this.$translate.instant("currency.create_another_title"),
      message: this.$translate.instant("currency.create_another_message"),
      callback: ({ modal }) => {
        modal.close();
        this.reset();
      },
      negative: ({ modal }) => {
        modal.close();
        this.$state.go('currency.all', { page: 1 });
      },
      type: "success",
    });
  }
}

export default CurrencyCreateController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/create/currency.create.controller.js